export function blankSurcharge() {
  return {
    perUnitCharge: '',
    chargeLabel: '',
    weightMinimum: '',
    weightMaximum: '',
    zoneMinimum: '',
    zoneMaximum: '',
    afterDate: '',
    beforeDate: ''
  };
}

export function toNumberOrNull(val, asInt) {
  if (val === '' || val === null || val === undefined) return null;
  var num = asInt ? parseInt(val, 10) : parseFloat(val);
  return isNaN(num) ? null : num;
}

// Descriptions must be unique within a rate card (case-insensitive, ignoring surrounding spaces).
export function labelKey(label) {
  return (label || '').trim().toLowerCase();
}

export function hasDuplicateLabels(entries) {
  var seen = {};
  return (entries || []).some(function(entry) {
    var key = labelKey(entry.chargeLabel);
    if (!key) return false;
    if (seen[key]) return true;
    seen[key] = true;
    return false;
  });
}

function toDateOrNull(val) {
  return val ? String(val).substring(0, 10) : null;
}

// Converts every empty input to null so the API receives real nulls instead of empty strings.
export function normalizeSurcharge(entry) {
  return {
    perUnitCharge: toNumberOrNull(entry.perUnitCharge, false) || 0,
    chargeLabel: (entry.chargeLabel || '').trim(),
    weightMinimum: toNumberOrNull(entry.weightMinimum, false),
    weightMaximum: toNumberOrNull(entry.weightMaximum, false),
    zoneMinimum: toNumberOrNull(entry.zoneMinimum, true),
    zoneMaximum: toNumberOrNull(entry.zoneMaximum, true),
    afterDate: toDateOrNull(entry.afterDate),
    beforeDate: toDateOrNull(entry.beforeDate)
  };
}
